var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-col',{attrs:{"cols":"12","sm":_vm.sm,"lg":_vm.lg,"align-self":"center"}},[_c('v-btn',{attrs:{"color":"primary","elevation":"2"},on:{"click":_vm.handleSearch}},[_c('v-icon',[_vm._v("mdi-magnify")]),_vm._v("검색 ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }